export const GET_PARTNER_DETAIL_ASYNC = 'GET_PARTNER_DETAIL_ASYNC'
export const GET_PARTNER_DETAIL_SUCCESS = 'GET_PARTNER_DETAIL_SUCCESS'
export const GET_PARTNER_DETAIL_FAIL = 'GET_PARTNER_DETAIL_FAIL'
